import React, { useEffect, useState } from 'react';
import i18n from 'locales/fa.json';
import Icon from 'components/Common/Icon';
import { StyledDialog, StyledDialogContent, StyledTypography } from './style';
import useDashboardStore from 'store/dashboard';
import { isIosPwa, isLandscape } from 'utils/common.util';

const RotateModal: React.FC = () => {
  const isFullScreen = useDashboardStore((state) => state.isFullScreen);
  const [openStatus, setOpenStatus] = useState(false);

  const handleRotate = (): void => {
    // use isFullScreen condition so modal status stays false in fullscreen mode
    setTimeout(() => {
      setOpenStatus(isLandscape() && !isFullScreen);
      if (!isLandscape() && isIosPwa()) {
        // set minHeight to body because of ios PWA issue that reduce innerHeight
        // when user returns back from external link
        window.localStorage.setItem('appHeight', `${window.innerHeight}px`);
      } else {
        // set 100% height for body in case of landscape in charts
        document.getElementsByTagName('body')[0].style.minHeight = '100%';
      }
    }, 100);
  };

  useEffect(() => {
    // call function first time in case that user opens app in landscape.
    handleRotate();

    // add event listener to check user orientation changes
    window.addEventListener('orientationchange', handleRotate);

    return () => {
      window.removeEventListener('orientationchange', handleRotate);
    };
  }, [isFullScreen]);

  const handleClose = (): void => {
    setOpenStatus(false);
  };

  return (
    <StyledDialog open={openStatus} fullScreen onClose={handleClose}>
      <StyledDialogContent>
        <Icon name="rotating-phone" fontSize="15rem" mx="auto" mb={10} />
        <StyledTypography>
          {i18n.global.messages.rotateMessage}
        </StyledTypography>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default RotateModal;
